/**
 * Имя человека в тесных местах.
 *
 * В цитате ответа и в узкой колонке полное «Дмитрий Саранцев» съедает
 * половину строки, а сам ответ ради него обрезается. «Саранцев Д.» читается
 * так же однозначно и вдвое короче — так подписывают в документах.
 */
export function shortName(full: string): string {
  const words = full.trim().split(/\s+/).filter(Boolean)
  if (words.length < 2) return full.trim()
  /* В базе имя идёт первым: «Дмитрий Саранцев» → «Саранцев Д.» */
  const first = words[0] ?? ''
  const last = words[words.length - 1] ?? ''
  return `${last} ${first.slice(0, 1).toUpperCase()}.`
}
